'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPC = void 0;
const utils = require("../utils");
const meterifyResult = function (result) {
    // tricks for compatible with original web3 instance
    // non-objects or non-arrays doesn't need isMeterified property since meterify just overwritten 3 formatters
    // which all accept object as input
    if (utils.isArray(result)) {
        result = result.map((item) => {
            Object.defineProperty(item, 'isMeterified', { get: () => true });
            return item;
        });
    }
    else if (utils.isObject(result)) {
        Object.defineProperty(result, 'isMeterified', { get: () => true });
    }
    return result;
};
class JSONRPC {
    constructor(payload) {
        this.id = payload.id;
        this.method = payload.method;
        this.params = payload.params;
    }
    makeResult(result) {
        return {
            id: this.id,
            jsonrpc: '2.0',
            result: meterifyResult(result),
        };
    }
    makeError(message) {
        return {
            id: this.id,
            jsonrpc: '2.0',
            error: {
                message,
            },
        };
    }
    makeSubResult(result) {
        return {
            id: this.id,
            jsonrpc: '2.0',
            method: this.method,
            params: {
                result: {
                    data: meterifyResult(result),
                },
                subscription: this.id,
            },
        };
    }
    makeSubError(error) {
        return {
            id: this.id,
            jsonrpc: '2.0',
            method: this.method,
            params: {
                result: {
                    error,
                },
                subscription: this.id,
            },
        };
    }
}
exports.JSONRPC = JSONRPC;
//# sourceMappingURL=data:application/json;base64,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